import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs';

import 'rxjs/add/operator/map'
import 'rxjs/add/operator/toPromise';

import { AuthService } from './../Seguridad/auth.service'



/**
* @author Camilo
* @since  26/10/2017
**/

declare var $: any;

@Injectable()
export class ServiciosGenerales {

	public path: string;

	public static temporalCrearFacturaComponent:any = null;
	constructor(private _http: Http, public seguridad: AuthService) {
								this.path = '/facturacion/rest';
								
	}

	get(query: string, info) {
		let header = new Headers({'Authorization-token': this.seguridad.getToken(), 'Active-form':this.seguridad.getInfoSesion().formularioActivo});
		let options = new RequestOptions({ headers: header });

		if (info == undefined || info == null)
			return this._http.get(this.path + "/" + query, options).map(res => res.json());
		else
			return this._http.get(this.path + "/" + query + '/' + encodeURIComponent(JSON.stringify(info)), options).map(res => res.json());
	}


	post(path: string, info) {

		let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization-token': this.seguridad.getToken(), 'Active-form':this.seguridad.getInfoSesion().formularioActivo });
		let options = new RequestOptions({ headers: headers });
		return this._http.post(this.path + "/" + path, info, options).map(res => res.json());
	}

	put(query: string, info) {
		let header = new Headers({'Authorization-token': this.seguridad.getToken(), 'Active-form':this.seguridad.getInfoSesion().formularioActivo});
		let options = new RequestOptions({ headers: header });
		return this._http.put(this.path + "/" + query, info, options).map(res => res.json());
	}

	putUrlParam(query: string, info) {
		let header = new Headers({'Authorization-token': this.seguridad.getToken(), 'Active-form':this.seguridad.getInfoSesion().formularioActivo});
		let options = new RequestOptions({ headers: header });
		return this._http.put(this.path + "/" + query+'/'+encodeURIComponent(JSON.stringify(info)), {}, options).map(res => res.json());
	}

	delete(query: string, info) {
		let header = new Headers({'Authorization-token': this.seguridad.getToken(), 'Active-form':this.seguridad.getInfoSesion().formularioActivo});
		let options = new RequestOptions({ headers: header });
		return this._http.delete(this.path + "/" + query + '/' + encodeURIComponent(JSON.stringify(info)), options).map(res => res.json());
	}

	getParametros(nombreFormulario:string, object:any){
		this.get('parametros', {formulario:nombreFormulario}).subscribe(result=>{
			if(result.error == true){
				alert("Ocurrió un error al momento de consultar los parametros por defecto: "+result.mensaje);
				return;
			}
			
			for(let x = 0 ; x < result.parametros.length ; x ++){
				let d = this.asignarRecursivo(object, result.parametros[x].vidcampo, result.parametros[x].contenido, -1);
				//object[result.parametros[x].vidcampo] = result.parametros[x].contenido;
			}

		}, error=>{
			console.log(error, '');
			alert("Ocurrió un error al momento de consultar los parametros por defecto");
		})
	}

	private asignarRecursivo(object:any, parametros:string, valor:string, indice:number){
		if(parametros.split(' ').join('') == '')
			return object;
		
		let x = parametros.split('.');
		if(indice + 1  == x.length -1 ){
			object[x[indice + 1]] = valor;
			return object;
		}else{
			indice = indice + 1;
			this.asignarRecursivo(object[x[indice]], parametros, valor, indice);
		}
	}

	descargarArchivo(path: string, info) {
		
		if (info == undefined || info == null) {
			$.fileDownload(this.path + "/" + path + "/" + this.seguridad.getToken(), {
				successCallback: function (url) {

					alert('You just got a file download dialog or ribbon for this URL :' + url);
				},
				failCallback: function (html, url) {

					alert('Ocurrió un error mientras se descarga el archivo, por favor intente más tarde ');
				}
			});
		} else {
			$.fileDownload(this.path + "/" + path + '/' + encodeURIComponent(JSON.stringify(info)) + "/" + this.seguridad.getToken(), {
				successCallback: function (url) {

					alert('You just got a file download dialog or ribbon for this URL :' + url);
				},
				failCallback: function (html, url) {

					alert('Ocurrió un error mientras se descarga el archivo, por favor intente más tarde ');
				}
			});
		}

	}


	public postUrlSpecial(url:string, info:any){
		return this._http.post(url, info).map(res => res.json());
	}


}


// WEBPACK FOOTER //
// D:/Repositorios/FacturacionWeb/src/app/main/content/Servicios/ServiciosGenerales.service.ts